export default __webpack_public_path__ + "static/assets/med_x_syringe_mask.73e52698.png";